module.exports = __webpack_public_path__ + "media/images/icon__plus@3x-e7730a2b58892aa3ad30a06ddc457aa0.png";